// Device-local record of physician-review requests this visitor made (no sign-in).
const KEY = "amd-reviews";
const MAX = 20;

export function getReviews() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function addReview({ request_id, question }) {
  if (!request_id) return;
  let list = getReviews().filter((r) => r.request_id !== request_id);
  list.unshift({ request_id, question: (question || "").trim(), ts: Date.now() });
  list = list.slice(0, MAX);
  try {
    localStorage.setItem(KEY, JSON.stringify(list));
  } catch {
    /* ignore */
  }
  return list;
}

export function reviewsForQuestion(question) {
  const q = (question || "").trim().toLowerCase();
  if (!q) return [];
  return getReviews().filter((r) => (r.question || "").toLowerCase() === q);
}
